export const API = "";

export const SINGLE_ASSET_DEFAULT = {
  asset_code: "000001.SZ",
  buy_date: "2024-01-02",
  quantity: "100",
  price: "9.3",
  actual_fee: "",
  valuation_date: "",
};

// ADR-010：原"核算截止日"tab 已撤销——查看截止日改为顶栏全局镜头（layout.jsx
// Header），重新核算入口移到详情页头部按钮。
export const DASHBOARD_TABS = [
  { key: "overview", label: "概览" },
  { key: "nav_drawdown", label: "净值与回撤" },
  { key: "holdings", label: "持仓分析" },
  { key: "attribution", label: "收益拆解" },
  { key: "transactions", label: "交易记录" },
  { key: "asset_events", label: "资产事件" },
  { key: "data_quality", label: "数据质量" },
];

// V0.4 AC-006/007/008：组合合集详情 tab。本期只做概览（含穿透持仓/成员贡献）
// 和成员组合管理——净值与回撤/收益拆解/资产事件/数据质量需要合集级 NAV 序列，
// 本期口径明确不支持（见 plan.md ADR-002），留到后续需要时再补。
export const COLLECTION_TABS = [
  { key: "overview", label: "概览" },
  { key: "nav_drawdown", label: "净值与回撤" },
  { key: "holdings", label: "穿透持仓" },
  { key: "attribution", label: "收益拆解" },
  { key: "asset_events", label: "资产事件" },
  { key: "members", label: "成员组合" },
  { key: "data_quality", label: "数据质量" },
];
